export const words = {
  place: 'Ort',
  yes: 'Ja',
  no: 'Nein',
  new: 'Neu',
  agb: 'AGB',
  agb_full: 'Allgemeine Geschäfts\u00ADbe\u00ADdin\u00ADgun\u00ADgen',
  datenschutzerklaerung: 'Datenschutzerklärung',
  status: 'Status',
  company_name: 'Unternehmensname',
  next_button: 'Weiter',
  device_name: 'Gerätename',
  to_connect: 'Verbinden',
  pin: 'PIN',
  time: 'Zeit',
  first_name: 'Vorname',
  last_name: 'Nachname',
  code: 'Code',
  help: 'Hilfe',
  total_time: 'Gesamtzeit',
  latitude: 'Breitengrad',
  longitude: 'Längengrad',
  accuracy: 'Genauigkeit',
  timestamp: 'Zeitstempel',
  device_id: 'Geräte-ID',
  active: 'aktiv',
  o_clock: 'Uhr',
  loading: 'Laden',
  annotation: 'Anmerkung',
  since: 'seit',
  camera: 'Kamera',
  map: 'Karte',
  gallery: 'Galerie',
  work: 'Arbeiten',
  employees: 'Mitarbeiter',
  login: 'Login',
  login_action: 'Anmelden',
  calendar_week_abbreviation: 'KW',
  calendar: 'Kalender',
  to_call: 'Anrufen',
  email: 'E-Mail',
  attachment: 'Anhang',
  operational_planning: 'Einsatzplan',
  to_scan: 'Scannen',
  download: 'Herunterladen',
  export: 'Exportieren',
  to_document: 'Dokumentieren',
  checklist: 'Checkliste',
  checklists: 'Checklisten',
  password: 'Passwort',
  confirmation: 'Bestätigung',
  confirm: 'Bestätigen',
  confirmation_email: 'Bestätigungsmail',
  unknown: 'Unbekannt',
  unknown_place: 'Unbekannter Ort',
  unknown_plan: 'Unbenannter Schichtplan',
  project_no: 'Projekt-Nr.',
  project_file: 'Projektakte',
  contact_person: 'Ansprechpartner',
  overtime: 'Überstunden',
  timesheet : 'Stundenliste',
  minustime: 'Minusstunden',
  back: 'Zurück',
  undo: 'Rückgängig',
  clockout: 'Ausstempeln',
  clocked_out: 'ausgestempelt',
  clockin: 'Einstempeln',
  clocked_in: 'eingestempelt',
  dismiss: 'Abbrechen',
  discard: 'Verwerfen',
  finish: 'Fertig',
  or: 'oder',
  copy: 'Kopieren',
  qr_code: 'QR-Code',
  documentation: 'Zeiterfassung & Dokumentation',
  attendance: 'Tablet-Terminal',
  tiercontent: 'Paketumfang',
  start_now: 'Jetzt loslegen',
  skip: 'Überspringen',
  logout_during_core_time: 'Ausgestempelt während Kernzeit',
  absent_during_core_time: 'Abwesend während Kernzeit',
  distance: 'Distanz',
  km_reading: 'Kilometerstand',
  the_start: 'Start',
  the_end: 'Ende',
  license_plate: 'Kennzeichen',
  details: 'Details',
  hide: 'ausblenden',
  cost: 'Kosten',
  file: 'Datei',
  address_book: 'Adressbuch',
  template_plural: 'Vorlagen',
  signature: 'Unterschrift',
  main_project: 'Hauptprojekt',
  main_projects: 'Hauptprojekte',
  sub_projects: 'Unterprojekte',
  scan_to_login_header: 'QR-Code Anmeldung',
  description: 'Beschreibung',
  project_location: 'Projektort',
  phone_number: 'Rufnummer',
  project_info: 'Projektinformationen',
  number_short: 'Nr.',
  sketch: 'Skizze',
  video: 'Video',
  delete: 'Löschen',
  send: 'Abschicken',
  sending: 'Senden...',
  save: 'Speichern',
  granted: 'genehmigt',
  pending: 'beantragt',
  denied: 'abgelehnt',
  customer: 'Kunde',
  mobile_number: 'Telefonnummer',
  ok: 'Ok',
  day: 'Tag',
  tomorrow: 'morgen',
  days: 'Tage | Tag | Tage',
  holidays: 'Feiertage',
  vacation_days: 'Urlaubstage',
  vacation_hours: 'Urlaubsstunden',
  request: 'Antrag',
  accept: 'Akzeptieren',
  withdraw: 'Zurückziehen',
  hour_account: 'Stundenkonto',
  period: 'Zeitraum',
  to: 'bis',
  date: 'Termin',
  number: 'Anzahl',
  message: 'Nachricht',
  change: 'ändern',
  changed: 'Geändert',
  changed_fields: 'Geänderte Felder',
  type: 'Art',
  hour: 'Stunde',
  hours: 'Stunden',
  hours_abbreviation: 'Std.',
  hours_with_amount: '{amount} Stunden',
  end: 'beenden',
  end_date: 'Endtermin',
  start_date: 'Starttermin',
  absence: 'Abwesenheit',
  month: 'Monat',
  week: 'Woche',

  transcript: 'Transkript',
  time_left: 'übrig',
  transcript_tasks: 'Aufgaben',
  add_task: 'Neu',
  /** Differentiation in some languages (e.g. English) */
  from: 'von',
  of: 'von',
  of_hours: 'von {hours} Stunden',
  of_hours_abbreviation: 'von {hours} Std.',

  /**************/


  used: 'benutzt',
  update: 'Aktualisieren',
  today: 'heute',
  correction: 'Korrektur',
  work_time: 'Arbeitszeit',
  break: 'Pause',
  loading_time: 'Ladezeit',
  driving_time: 'Fahrzeit',
  business_trip: 'Dienstgang',
  project: 'Projekt',
  special_one: 'Sonder1',
  special_two: 'Sonder2',
  clock: 'Uhr',
  search: 'Suche',
  operation: 'Tätigkeit',
  day_protocol: 'Tagesprotokoll',
  continue: 'weiter',
  total_duration: 'Gesamtzeit',
  duration: 'Dauer',
  hello: 'Hallo',
  close: 'schließen',
  comment: 'Kommentar',
  small: 'klein',
  medium: 'mittel',
  large: 'groß',
  sharpie: 'Stift',
  line: 'Linie',
  arrow: 'Pfeil',
  rectangle: 'Rechteck',
  ellipse: 'Ellipse',
  text: 'Text',
  language_settings: 'Spracheinstellungen',
  clock_reminder: 'Stempelerinnerung',
  individually: 'Individuell',
  from_o_clock: 'von',
  to_o_clock: 'bis',
  eraser: 'Radierer',
  edit: 'Bearbeiten',
  legal_notes: 'Rechtliches',
  notes: 'Notizen',
  note: 'Notiz',
  imprint: 'Impressum',
  open_source_licenses: 'Open-Source-Lizenzbestimmungen',
  author: 'Autor',
  license_type: 'Lizenztyp',
  version: 'Version',
  substitute: 'Vertretung',
  not_rated: 'Nicht gewertet',
  weekly_working_hours: 'Wochenarbeitszeiten',
  show_less: 'Weniger anzeigen',
  office_center: 'Bürocenter',
  admin_view: 'NFC-Verwaltung',
  register: 'Registrieren',
  shifts:{
    shift_attachments: 'Anhänge (Schicht)',
    shift_plan_attachments: 'Anhänge (Schichtplan)',
    shift_plan: 'Schichtplan',
    shift:'Schicht',
  },
  absences: {
    sick: 'Krankheit (Lohnfortzahlung)',
    vacation: 'Urlaub',
    workshop: 'Seminar/Lehrgang',
    special_vacation: 'Sonderurlaub',
    school: 'Schule',
    working_time_account: 'Arbeitszeitkonto',
    holiday: 'Feiertag',
    other: 'Sonstiges',
    driving_time: 'Fahrzeit',
    parental_leave: 'Elternzeit',
    excused_absent: 'Fehlt entschuldigt (bezahlt)',
    not_excused_absent: 'Fehltag unentschuldigt',
    sick_industrial_accident: 'Krankheit Betriebsunfall (LFZ)',
    short_time_work: 'Kurzarbeit (Kug)',
    maternity_pay: 'Mutterschutzlohn/Beschäftigungsverbot',
    sick_child: 'Pflege krankes Kind mit Kranken(tage)geld',
    sick_child_no_payment: 'Pflege krankes Kind ohne Kranken(tage)geld',
    vacation_no_payment: 'Unbezahlter Urlaub',
    sick_before_short_time_work: 'Krankengeld/Krankheit vor Kug',
    weather_related_failure: 'Witterungsbedingter Ausfall',
    sick_short_time_work: 'Krankheit während Kug',
    sick_no_payment: 'Krankheit (ohne Lohnfortzahlung)',
    company_vacation: 'Betriebsferien',
    meals_14_euro: 'Kleine Verpflegungspauschale',
    meals_28_euro: 'Große Verpflegungspauschale',
  },
  image_editor: {
    font_size: 'Schriftgröße',
    stroke_width: 'Linienstärke',
    stroke_color: 'Linienfarbe',
    text_color: 'Schriftfarbe',
    rotate_left: 'Nach links drehen',
    rotate_right: 'Nach rechts drehen',
    flip_horizontal: 'Horizontal spiegeln',
    flip_vertical: 'Vertikal spiegeln',
  },
  travel_log: {
    method_of_transportation: 'Verkehrsmittel',
    company_car: 'Dienstwagen',
    private_car: 'Privatauto',
    rental_car: 'Mietwagen',
    taxi: 'Taxi',
    public_transportation : 'Öffentlicher Nahverkehr',
    airplane: 'Flugzeug',
    train: 'Bahn (öffentlicher Fernverkehr)',
    other: 'Andere',
    km_reading_start: 'Kilometerstand Anfang',
    km_reading_end: 'Kilometerstand Ende',
    net_expenses: 'Fahrtkosten (netto)',
    tax: 'Umsatzsteuer',

  },
  read_in : 'Einlesen',
  currency: 'Währung',
  reason: 'Begründung',
  label: 'Label',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  break_alarm: 'Pausenwecker',
  clockin_reminder: 'Einstempelerinnerung',
  clockout_reminder: 'Ausstempelerinnerung',
}
